export const DepositActivityName = {
  TANNING: 'tanning',
  MECHANICAL_DRYING: 'mechanical_drying',
  BUY: 'buy',
  INVENTORY: 'inventory',
  DOWNLOAD: 'download',
  USE: 'use',
  DEFENSE: 'defense',
};
